define(["@modules/utils"], function (utils) {
    var $ = require("jquery");

    $(".collect-email-plan-finder").each(function () {
        var $this = $(this);

        var form = $this;
        var textField = $this.find("input[type=text]");
        var formDisplay = $this.find(".form-display");
        var serverErrorDisplay = $this.find(".server-error");
        var validationErrorDisplay = $this.find(".validation-error");
        var thankYouDisplay = $this.find(".thank-you");
        var loading = $this.find(".loading");

        textField.change(function () {
            validationErrorDisplay.hide();
        });

        form.submit(function (e) {
            validationErrorDisplay.hide();
            serverErrorDisplay.hide();
            loading.show();
            e.preventDefault();

            $.ajax({
                url: "/api/planemailcollection/addemail",
                type: "POST",
                data: {
                    Email: textField.val()
                },
                headers: {
                    RequestVerificationToken: utils.getRequestVerificationToken()
                }
            })
                .done(function () {
                    formDisplay.hide();
                    thankYouDisplay.show();
                    thankYouDisplay.focus();
                })
                .fail(function (jqXHR, status, error) {
                    if (jqXHR.status === 400) {
                        validationErrorDisplay.show();
                        textField.focus();
                    } else {
                        serverErrorDisplay.show();
                        textField.focus();
                    }
                })
                .always(function () {
                    loading.hide();
                });
        });
    });
});
